module.exports = __webpack_public_path__ + "img/avatar-default.4c8a219e.png";